import loadable from '@loadable/component';

export const ErrorPageLoadable = loadable(() => import('./ErrorPage'), {
  resolveComponent: (module) => module.ErrorPage,
});
